import { render } from "./Trombinoscope.vue?vue&type=template&id=12a2c5a8&scoped=true"
import script from "./Trombinoscope.vue?vue&type=script&lang=js"
export * from "./Trombinoscope.vue?vue&type=script&lang=js"

import "./Trombinoscope.vue?vue&type=style&index=0&id=12a2c5a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a2c5a8"]])

export default __exports__